<script lang="ts">
import { defineComponent } from 'vue'
import KeywordsMain from './Main.vue'
import KeywordsAsideSecondary from './AsideSecondary.vue'
import KeywordsBreadcrumb from './Breadcrumb.vue'
import PageHeadingDefault from '@/components/_core/PageHeadingDefault.vue'

export default defineComponent({
  name: 'KeywordsApp',

  components: {
    KeywordsMain,
    KeywordsAsideSecondary,
    KeywordsBreadcrumb,
    PageHeadingDefault,
  },
})
</script>

<template>
  <TemplateDefault>
    <template #breadcrumbHeader>
      <KeywordsBreadcrumb />
    </template>

    <template #pageHeading>
      <PageHeadingDefault>
        用語解説
      </PageHeadingDefault>
    </template>

    <template #main>
      <KeywordsMain />
    </template>

    <template #asideSecondary>
      <KeywordsAsideSecondary />
    </template>

    <template #breadcrumbFooter>
      <KeywordsBreadcrumb />
    </template>
  </TemplateDefault>
</template>
